import { render, staticRenderFns } from "./DisableTotp.vue?vue&type=template&id=1a9617dd"
import script from "./DisableTotp.vue?vue&type=script&lang=ts"
export * from "./DisableTotp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a9617dd')) {
      api.createRecord('1a9617dd', component.options)
    } else {
      api.reload('1a9617dd', component.options)
    }
    module.hot.accept("./DisableTotp.vue?vue&type=template&id=1a9617dd", function () {
      api.rerender('1a9617dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/DisableTotp.vue"
export default component.exports